import Hsp2 from './Hsp2';

export default Hsp2;
